// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import * as _ from "lodash";
import { connect } from 'react-redux';
import Close from '../Icons/Close';
import * as actions from '../../modules/actions';
import * as selectors from '../../modules/selectors';

const PopupWrapper = styled.div`
    position: fixed;
    bottom: 20px;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 100;
    transition: all 0.2s linear 0s;
`;

const ModalCloseStyled = styled.button`
	padding-top: 4px;
    cursor: pointer;
    background: none;
    border: none;
`;

const PopUpContainer = styled.div`
    width: 90%;
    max-width: 80%;
    min-height: 80px;
    opacity: 1;
    height: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: row-reverse;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
    box-shadow: rgba(127, 138, 144, 0.5) 0px 0px 20px 0px;
    transition: all 0.2s linear 0s;
    padding: 28px 30px 26px;
    margin: 0 auto;
    border-radius: 5px;
    background #ffffff;
    position: relative;
    font-family: RLFont,sans-serif;
    b{
        font-weight: 700;
    }
`;

type Props = {
	fetchNotifications: Function,
    hideNotificationBar: Function,
    notification_bar: {
        text: '',
        show: boolean,
    }
}

type State = {
    show: boolean 
}
export class NotificationBar extends Component<Props, State> {

	constructor(props: Props, state: State) {
		super(props, state);
		this.state = {
			show: true,
		};
		_.bindAll(this, [
			'handleClose',
		]);
	}
	componentDidMount(){
		this.props.fetchNotifications();
	}
	handleClose() {
		this.setState({
			show: false,
		});
		this.props.hideNotificationBar();
	}
	render() {
		const { notification_bar } = this.props;

		if(!notification_bar.show || !this.state.show){
			return null;
		}
		return(
			<PopupWrapper>
				<PopUpContainer >
					<ModalCloseStyled onClick={this.handleClose}>
						<Close />
					</ModalCloseStyled>
					<div dangerouslySetInnerHTML={{ __html: notification_bar.text }}>

					</div>

				</PopUpContainer>

			</PopupWrapper>
		);
	}
}

const mapStateToProps = state => ({
	notification_bar: selectors.notificationBar.getNotificationBar(state)
});

const mapDispatchToProps = ({
	fetchNotifications: actions.fetchNotificationBar,
	hideNotificationBar: actions.hideNotificationBar,
});


export default connect(mapStateToProps, mapDispatchToProps)(NotificationBar);


// WEBPACK FOOTER //
// ./src/components/NotificationBar/index.js